import React, { Component } from 'react';
import { connect } from 'react-redux';
import TableC from '../../basicElement/TableC';
import { Modal, Button, message } from 'antd';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import { queryApprovalUserCachedAsync } from '../../../common/permissionCache';
import Log from './components/Log';
import Filter from './components/Filter';
import Update from './components/Update';
import Approve from './components/Approve';
import Attachment from './components/Attachment';
import ProjectSideNav from '../../projectContract/SideNav';
import ExportUtil from '../../../common/ExportUtil';
import { saveParams } from '../../../actions/noticeActions';
import cf from '../../../utils/cf';
import fp from '../../../utils/fp';
import SideNav from '../SideNav';

class ContractInfoChange extends Component {
    constructor(props) {
        super(props);
        const { params } = props;
        const searchParams = {};
        if (params.applyCode) {
            searchParams.applyCode = params.applyCode;
        }
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            curParams: {...searchParams},
            searchParams,
            pagination: {
                pageSize: 10,
                current: 1,
            },
            businessList: [],
            invStageList: [],
            addable: false,
            params:{...params}
        };
    }
    
    componentDidMount() {
        this.queryApprovalUser();
        this.loadData();
        this.queryWithLevelByParams();
        this.updateIsShow();
    }

    updateIsShow = () =>{
        const { params } = this.props;
        if(params.investigationId && webCondition === 'NEED_POP'){
            this.update(params, 'add')
        }
    }

    componentWillUnmount() {
        const { saveParams } = this.props;
        saveParams({ applyCode: '',investigationId:null });
    }

    // 查询添加人员
    queryApprovalUser = () => {
        queryApprovalUserCachedAsync('BAL_CONTRACT_MODIFY')
        .then(res => {
            const { BAL_CONTRACT_MODIFY } = res;
            const { curEmployeeCode } = sessionStorage;
            this.setState({ addable: (BAL_CONTRACT_MODIFY || []).includes(curEmployeeCode) });
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            Fetch.post(API_URL.common.queryWithLevelByParams, { typeName: 'LINE_OF_BUSINESS' })
                .then(cb)
                .catch(err => {
                    console.error(err);
                });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    queryInvestigationStageByInvId = (investigationId, callback) => {
        this.setState({ loading: true });
        Fetch.post(API_URL.investigation.queryInvestigationStageByInvId, { investigationId })
        .then(res => {
            const { data } = res;
            this.setState({
                loading: false,
                invStageList: data,
            }, () => {
                callback && this.canEditByInvStatus(callback);
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = this.splitParams(curParams);
        Fetch.post(API_URL.contract.queryInvestigationJdeContractModifyApplyList, {
            offset: current,
            limit: pageSize,
            ...sortParams,
            ...params,
            curInvId: '',
        }).then(res => {
            const { datas, totalCount ,isInvPM } = res;
            pagination.total = totalCount;
            this.setState({
                loading: false,
                data: datas,
                pagination,
				isInvPM: isInvPM
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState(
            {
                pagination,
                curParams: { ...searchParams },
            },
            () => {
                this.loadData();
            }
        );
    };
    download = (params) => {
        ExportUtil.export(params, null, API_URL.contract.downloadJdeCodeEnclosure);
        message.success('正在下载中!')
    }
    export = () => {
        const { sortParams, searchParams } = this.state;
        const url = API_URL.contract.exportInvestigationJdeContractModifyApplyList;
        ExportUtil.export({ ...sortParams, ...searchParams }, null, url);
    }

    delete = (record) => {
        Modal.confirm({
            iconType: 'question-circle',
            title: "确定要撤销吗？",
            onOk: () => {
                const { investigationJdeContractModifyApplyId } = record;
                this.setState({ loading: true });
                Fetch.post(API_URL.contract.deleteInvestigationJdeContractModifyApply, {
                    investigationJdeContractModifyApplyId,
                }).then(res => {
                    message.success(res.success);
                    this.setState({ loading: false }, () => {
                        this.loadData();
                    });
                }).catch(error => {
                    console.error(error);
                    this.setState({ loading: false });
                });
            },
        });
    }

    getColumns = () => {
        const { curRole, invState, userId } = sessionStorage;
        const isHome = invState == 0;
        const {data} = this.setState;
        const columns = [{
            title: '申请编号',
            dataIndex: 'applyCode',
            key: 'applyCode',
            fixed: 'left',
            width: 100,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            fixed: 'left',
            width: 160,
        }, {
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            width: 100,
        }, {
            title: '合同主键',
            dataIndex: 'investigationJdeContractId',
            key: 'investigationJdeContractId',
            width: 100,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 100,
        }, {
            title: '变更字段',
            dataIndex: 'fieldTypeName',
            key: 'fieldTypeName',
            width: 100,
        }, {
            title: '变更前',
            dataIndex: 'oldValue',
            key: 'oldValue',
            width: 160,
            render:(text,record)=>{
                const { fieldType,oldList } = record;
                if (fieldType === 'contractFile') {
                    return (
                        oldList.map((el)=>{
                            return (
                                <div>
                                <a onClick={() => this.download({ fileMetaId:el.fileMetaId })}>{el.fileName}</a>
                            </div>
                            )
                        })
                        
                    );
                }else {
                    return text;
                }
            }
        }, {
            title: '变更后',
            dataIndex: 'newValue',
            key: 'newValue',
            width: 160,
            render: (text, record) => {
                const { fieldType, baUserName, baUserCode,newList } = record;
                if (fieldType === 'customerCompany') {
                    return (
                        <span>
                            {text}
                            (BA：{baUserName}[{baUserCode}])
                        </span>
                    );
                }else if (fieldType === 'contractFile') {
                    return (
                        newList.map((el)=>{
                            return(
                                <div>
                                <a onClick={() => this.download({ fileMetaId:el.fileMetaId })}>{el.fileName}</a>
                            </div>
                            )
                        })
                    );
                }else {
                    return text;
                }
            }
        }, {
            title: '变更原因',
            dataIndex: 'reason',
            key: 'reason',
            width: 160,
        }, {
            title: '申请人',
            dataIndex: 'userName',
            key: 'userName',
            width: 100,
        }, {
            title: '申请时间',
            dataIndex: 'createDateShow',
            key: 'createDateShow',
            width: 100,
        }, {
            title: '申请状态',
            dataIndex: 'approvalContent',
            key: 'approvalContent',
            width: 100,
        }, {
            title: '成功变更时间',
            dataIndex: 'successDateShow',
            key: 'successDateShow',
            width: 100,
        }, {
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            fixed: 'right',
            width: 140,
            render: (text, record) => {
                const { applyStatus, approvalStatus, applyUserId, roleCode, pmUserIds, investigationId,showApprove } = record;
                const isPmCreate = (curRole === 'PM' || curRole === 'PML') && (roleCode === 'PM' || roleCode === 'CRC' || roleCode === 'CRCC' || roleCode === 'CRCM');
                const isCurrentBaCreate = isHome && (curRole === 'BA' || curRole === 'BAL') && (applyUserId == userId);
                const otherRole = !(curRole === 'PM' || curRole === 'PML' || curRole === 'BA' || curRole === 'BAL' || curRole === 'FIN');
                const otherRoleEdit = isHome && otherRole && (pmUserIds || '').split(',').includes(userId) && (roleCode === 'PM' || roleCode === 'CRC' || roleCode === 'CRCC' || roleCode === 'CRCM');
                const edit_display = (applyStatus === 'Pending_Approval' || applyStatus === 'Approval_Failed') && (isPmCreate || isCurrentBaCreate || otherRoleEdit);
                const delete_display = applyStatus === 'Pending_Approval'&& !approvalStatus && (isPmCreate || isCurrentBaCreate || otherRoleEdit);
                //const approve_display = applyStatus === 'Pending_Approval';
				const approve_display = showApprove === '1';
                const operationCorrespondRoles = new Map([
                    ['edit', {
                        name: '修改',
                        display: edit_display,
                        editable: true,
                        event: () => this.queryInvestigationStageByInvId(investigationId, () => this.update(record, 'edit')),
                        roles: ['*'],
                    }],
                    ['delete', {
                        name: '撤销',
                        display: delete_display,
                        editable: true,
                        event: () => this.queryInvestigationStageByInvId(investigationId, () => this.delete(record)),
                        roles: ['*'],
                    }],
                    ['approve', {
                        name: '审批申请',
                        display: approve_display,
                        editable: true,
                        event: () => this.queryInvestigationStageByInvId(investigationId, () => this.showApprove(record)),
                        roles: ['*'],
                    }],
                    ['attachment', {
                        name: '查看附件',
                        display: true,
                        editable: true,
                        event: () => this.showAttachment(record),
                        roles: ['*'],
                    }],
                    ['log', {
                        name: '操作日志',
                        display: true,
                        editable: true,
                        event: () => this.showLog(record),
                        roles: ['*'],
                    }],
                ]);
                return (
                    <span>
                        {   fp.compose(
                                fp.curry(cf.operationAuthByRole)(index => <span key={index} className="ant-divider" />),
                                fp.filter(i => !!i),
                                // 获取角色对应操作
                                fp.curry(cf.authDomList)(operationCorrespondRoles)
                            )(curRole)
                        }
                    </span>
                );
            }
        }];
        return columns;
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    update = (record, type) => {
        this.updateRef.show({...record}, type);
    }

    showApprove = (record) => {
        this.approveRef.show(record);
    }

    showLog = (record) => {
        this.logRef.show(record);
    }

    showAttachment = (record) => {
        this.attachmentRef.show(record);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    render() {
        const { invState, curRole, invId } = sessionStorage;
        const { data, loading, pagination, searchParams, sortParams, businessList,isInvPM,params } = this.state;
		var {addable} = this.state;
		//这边有问题的，需要判断当前用户有没有作为项目PM，不能简单根据职位角色来判断
		// if (isInvPM == '1') {
		// 	addable = true;
		// }
        const isTotal = invState == 1;
        const update = isTotal ? () => this.queryInvestigationStageByInvId(invId, () => this.update({}, 'add')) : () => this.update({}, 'add');
        return (
            <div className="content">
                {
                   isTotal ?
                        <ProjectSideNav selectKey='contractInfoChange' />
                    :
                        <SideNav selectKey='contractInfoChange' />
                }
                <div className="main">
                    <Filter
                        search={this.search}
                        params={searchParams}
                        businessList={businessList}
                        onChange={this.handleFilterChange}
                        buttons={[
                            <Button key="export" type="primary" onClick={this.export}>导出</Button>,
                            (isTotal ? curRole === 'PM' : addable) && <Button key="add" type="primary" onClick={update}>添加</Button>
                        ]}
                    />
                    <TableC
                        data={data}
                        scrollY={570}
                        loading={loading}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        pagination={pagination}
                        className="contractInfoChange"
                        onChange={this.handleTableChange}
                    />
                    <Log ref={el => this.logRef = el} />
                    <Attachment ref={el => this.attachmentRef = el} />
                    <Approve ref={el => this.approveRef = el} loadData={this.loadData} />
                    <Update ref={el => this.updateRef = el} businessList={businessList} loadData={this.loadData} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContractInfoChange);



// WEBPACK FOOTER //
// ./src/components/contractManagement/contractInfoChange/index.js